var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CartUtil from './cartUtil';
let CartState = [];
const getCartItems = () => __awaiter(void 0, void 0, void 0, function* () {
    if (CartState.length > 0) {
        return CartState;
    }
    return yield CartUtil.get(false).then((result) => {
        const items = result.items;
        CartState = items;
        return CartState;
    });
});
const getItemCount = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield CartUtil.get(false).then((result) => {
        const itemCount = result.item_count;
        return itemCount;
    });
});
export default {
    getCartItems,
    getItemCount,
};
